export default __webpack_public_path__ + "assets/images/00b4348ef89db29f535a74bbb7a9984c.jpg";